import React from 'react';
import { Button, styled } from '@landr/maestro';
import { useAuthentication } from 'components/Authentication';

export const StyledButton = styled(Button)`
    padding: 14px;
    height: auto;
    line-height: inherit;
    @media (max-width: 1024px) {
        padding: 12px;
    }
`;

const SignUpOrGoToApp = ({ label, goToAppLabel }: { label: string; goToAppLabel: string }) => {
    const { isAuthenticated, signupUrl } = useAuthentication();

    return (
        <StyledButton>
            <a href={isAuthenticated ? process.env.GATSBY_APP_ENDPOINT : signupUrl}>
                {isAuthenticated ? goToAppLabel : label}
            </a>
        </StyledButton>
    );
};

export default SignUpOrGoToApp;
